export default __webpack_public_path__ + "static/media/FACINGSLogoNegative.36a3b8b2.png";